export function TimeoutError(...args) {
  const native = Error.apply(this, args);
  this.name = 'TimeoutError';
  this.message = native.message;
  this.stack = native.stack;
}

TimeoutError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: TimeoutError,
  },
});

export default function createTimeoutFetch(defaultTimeout) {
  return (path, opts = {}) => {
    const timeout = defaultTimeout;
    return Promise.race([
      fetch(path, opts),
      new Promise((res, rej) => {
        setTimeout(
          // fetch currently doesn't have a way to stop the request
          // https://github.com/whatwg/fetch/issues/27
          // TODO: be sure to add that call here once/if that is added to the API
          () => rej(new TimeoutError(`${path} after ${timeout}ms`)),
          timeout
        );
      }),
    ]);
  };
}
